import { TabInfoBase } from 'app/buffer-graph/models/tab-info-base';
import { ItemOrderHistory } from 'app/buffer-graph/models/item-order-history/item-order-history';
import { ItemOrderHistoryFresh } from 'app/buffer-graph/models/item-order-history/item-order-history-fresh';

type History = ItemOrderHistory | ItemOrderHistoryFresh;
type Data = { isFresh: boolean, sku: string, warehouseCode: string, orders: History[], canSend: boolean, isAll?: boolean };

export class ItemOrderHistoryTabInfo extends TabInfoBase<Data> {
    constructor(data: Data) {
        super('ItemOrderHistory', data);
    }

    get id(): string {
        return ItemOrderHistoryTabInfo.id;
    }

    static readonly id = 'IOH';
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/item-order-history/item-order-history-tab-info.ts